import React, { useState } from "react";
import { Container, Card } from "@material-ui/core";
import { Button } from "@material-ui/core";
import DownloadJsonDialog from "./components/DownloadJson";
import DownloadTgzDialog from "./components/DownloadTgz";
import { listenToDragDrop } from "./utils/functions";
import Remote from "./components/Remote";
import Navigation from "./components/Navigation";

listenToDragDrop();

export default () => {
  const [isDownloadJsonOpen, setIsDownloadJsonOpen] = useState(false);
  const [isDownloadTgzOpen, setIsDownloadTgzOpen] = useState(false);
  return (
    <div className="App">
      <Navigation />
      <Container style={{ marginTop: 75 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 10,
          }}
        >
          <Button
            style={{ marginRight: 10 }}
            disabled={false}
            variant="contained"
            color="primary"
            onClick={() => setIsDownloadJsonOpen(true)}
          >
            Download JSON
          </Button>

          <Button
            disabled={false}
            variant="contained"
            color="primary"
            onClick={() => setIsDownloadTgzOpen(true)}
          >
            Download TGZ
          </Button>
        </div>
        <DownloadJsonDialog
          isDownloadJsonOpen={isDownloadJsonOpen}
          close={() => setIsDownloadJsonOpen(false)}
        />
        <DownloadTgzDialog
          isDownloadTgzOpen={isDownloadTgzOpen}
          close={() => setIsDownloadTgzOpen(false)}
        />
        <Card style={{ padding: "2rem" }}>
          <Remote />
        </Card>
      </Container>
    </div>
  );
};
